import { ApolloError } from "@apollo/client";
import { appendBrandNameIfPresent, PROJECT_CATCH_ERROR_LIST } from "@platformx/utilities";
import graphqlInstance from "../../config/graphqlConfig";
import { ArticleQueries } from "../../graphQL/queries/articleQueries";
import { FETCH_TAG_LIST_QUERY } from "../../graphQL/queries/tagQueries";
import { ApiResponse } from "../../utils/types";

const withBrandNameInput = (variables: any): any => {
  if (!variables?.input) return variables;
  return { ...variables, input: appendBrandNameIfPresent(variables.input) };
};

const articleApi = {
  getList: async <T>(input: any): Promise<ApiResponse<T>> => {
    try {
      const { data } = await graphqlInstance.query({
        query: ArticleQueries.FETCH_CONTENT_LIST_ALL,
        variables: withBrandNameInput(input),
        fetchPolicy: "no-cache",
      });
      return data;
    } catch (err: any) {
      if (err instanceof ApolloError) {
        /* Apollo errors */
      }
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:articleApi`, err);
      throw err;
    }
  },
  createArticle: async <T>(input: any): Promise<ApiResponse<T>> => {
    try {
      const { data } = await graphqlInstance.query({
        query: ArticleQueries.CREATE_CONTENT,
        variables: withBrandNameInput(input),
        fetchPolicy: "no-cache",
      });
      return data;
    } catch (err: any) {
      if (err instanceof ApolloError) {
        /* Apollo errors */
      }
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:createArticle`, err);
      throw err;
    }
  },
  publishArticle: async <T>(input: any): Promise<ApiResponse<T>> => {
    try {
      const { data } = await graphqlInstance.query({
        query: ArticleQueries.PUBLISH_CONTENT,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return data;
    } catch (err: any) {
      if (err instanceof ApolloError) {
        /* Apollo errors */
      }
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishArticle`, err);
      throw err;
    }
  },
  fetchArticleDetails: async <T>(input: any): Promise<ApiResponse<T>> => {
    try {
      const { data } = await graphqlInstance.query({
        query: ArticleQueries.FETCH_CONTENT_BY_PATH,
        variables: withBrandNameInput(input),
        fetchPolicy: "no-cache",
      });
      return data;
    } catch (err: any) {
      if (err instanceof ApolloError) {
        /* Apollo errors */
      }
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchArticleDetails`, err);
      throw err;
    }
  },
  updateArticle: async <T>(input: any): Promise<ApiResponse<T>> => {
    try {
      const { data } = await graphqlInstance.query({
        query: ArticleQueries.UPDATE_CONTENT,
        variables: withBrandNameInput(input),
        fetchPolicy: "no-cache",
      });
      return data;
    } catch (err: any) {
      if (err instanceof ApolloError) {
        /* Apollo errors */
      }
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:updateArticle`, err);
      throw err;
    }
  },
  getTags: async <T>(input: any): Promise<ApiResponse<T>> => {
    try {
      const { data } = await graphqlInstance.query({
        query: FETCH_TAG_LIST_QUERY,
        variables: input,
        fetchPolicy: "no-cache",
      });
      return data;
    } catch (err: any) {
      if (err instanceof ApolloError) {
        /* Apollo errors */
      }
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:getTags`, err);
      throw err;
    }
  },
};
export default articleApi;
